<script>
import Pagination from "./PromotionPagination";
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import prevencionEmergenciasAPI from "@/services/standards/prevencionEmergencias/prevencionEmergenciasAPI";
import prevencionEmergenciasActasAPI from "../../../../services/standards/prevencionEmergenciasActas/prevencionEmergenciasActasAPI";

export default {
  components: { Pagination },
  props: {
    companyID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      themes: [],
      search: null,

      itemData: null,
    };
  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },

    getItemData() {
      ItemAPI.getItems(9)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find((permission) => permission.name === name);

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    go(ID) {
      this.$router.push({
        path: `/forms/estandares/${this.companyID}/promocion-prevencion/${ID}`,
      });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    deleteActa(id) {
      prevencionEmergenciasActasAPI.delete(id)
        .then((data) => {
          Swal.fire({
            title: "Se ha sido eliminado con exito!",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getThemeID(theme) {
      if (theme === "BIOLÓGICO") {
        return 1;
      } else if (theme === "FÍSICO") {
        return 2;
      } else if (theme === "QUÍMICO") {
        return 3;
      } else if (theme === "PSICOSOCIAL") {
        return 4;
      } else if (theme === "BIOMECÁNICO") {
        return 5;
      } else if (theme === "CONDICIONES") {
        return 6;
      } else if (theme === "FENÓMENOS") {
        return 7;
      } else {
        return 8;
      }
    },
  },
  mounted() {
    this.getItemData();
  },
};
</script>


<template>
  <div>
    <table
      class="pt-2 table table-sm table-responsive border-bottom max-w-full divide-y divide-gray-200 table-striped rounded col-sm-12">
      <thead class="table-active">
        <tr>
          <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4">
            Fecha
          </th>
          <th scope="col" class="px-7 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4">
            Descripcion del archivo
          </th>
          <th scope="col" class="px-4 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4">
            Ver archivo
          </th>
          <th scope="col" class="px-6 text-left text-xs font-medium text-gray-500 align-middle mx-2 col-sm-4">
            Acciones
          </th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr v-for="item in themes" :key="item.id">
          <td class="px-6 text-sm text-gray-500 mx-2">
            {{ dateConvert(item.created_at) }}
          </td>
          <td class="px-7 text-sm text-gray-500 mx-2">
            Plan de emergencia
          </td>
          <td class="px-5 text-sm text-gray-500 mx-2">
            <div v-if="item.file === null">
              <h6>No hay archivo disponible
              </h6>
            </div>
            <div v-else>
              <button :disabled="!allowAccess()" style=" background-color: transparent !important; border: none;"
                type="button" @click="gotoDigitalOcean(`${item.file}`)"> <i class="mdi mdi-cloud-download"></i>
              </button>
            </div>
          </td>
          <td class="px-6 text-sm text-gray-500 mx-2 align-middle text-center">
            <div class="col-sm-12">
              <b-dropdown variant="primary" :disabled="!allowAccess()">
                <template v-slot:button-content>
                  <i class="mdi mdi-eye"></i>
                </template>
                <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')"  :to="{ path: `/forms/estandares/prevencion-emergencias-actas-editar/${item.id}` }">
                  Editar
                </b-dropdown-item>
                <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                  v-on:click="deleteActa(item.id)">Eliminar</b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <Pagination :companyID="companyID" ref="paginator" :search="search" @fetch="(items) => (themes = items)" />
  </div>
</template>

